import ApiService from "../../../ApiService";

const AssignmentDetailsService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/assignmentdetails/loadscreenview", vo, successCallback, failureCallback);
    },
    reorderUnit: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/assignmentdetails/reorderunit", vo, successCallback, failureCallback);
    },
    deleteUnit: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/assignmentdetails/deleteunit", vo, successCallback, failureCallback);
    },
    assign: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/assignmentdetails/assign", vo, successCallback, failureCallback);
    },
    assignByTask: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/assignmentdetails/assignbytask", vo, successCallback, failureCallback);
    },
    getTaskProgress: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/assignmentdetails/gettaskprogress", { id }, successCallback, failureCallback);
    },
};

export default AssignmentDetailsService;
